module.exports = __webpack_public_path__ + "img/type_1.a150f430.png";